// App.js
import React from 'react';
import '../App.css';
import Divider from './divider';
import jacob_pic from '../assets/Jacob_Square_Pic.jpg';


const data = {              
  photo: jacob_pic,
  text: "Instead of a salary, I make my money the exact same way as everybody else.",
  name: "Jacob Chapman",
  title: "CEO, Desert North Realty",
}


const About = () =>  {
  const { photo, text, name, title } = data;
  return (

  <div className='center' style={{backgroundColor:'#FFF', marginTop:'5em'}}>
    <div className='flex' style={{width:'80%', backgroundColor:'transparent'}}>
      <div className='auto-scale-text-lg color-primary ' style={{textAlign:'left', width:'100%'}}>AGENTS FOR AGENTS</div>
      <div className='auto-scale-text-med color-secondary ' style={{textAlign:'left',  width:'100%'}}>“When you hand good people possibility, they do great things.” <span style={{ color:'#BCD400'}}>– Biz Stone</span></div>
      <Divider color='#BCD400' width='90px' margin='30' alignment='left'/>
      
      <div className='text-content color-secondary' style={{textAlign:'left', width:'100%'}}>In an ever-changing industry, the legacy brokerage models continue to lose market share to companies like ours. Agents realize hefty corporate salaries and shareholder success no longer translate to their individual success. Watch the 4-minute video below and find out what the Desert North Realty difference is all about.</div>
      
      

    
    
    </div>

      
    </div>

  );
}

export default About;